(() => {
  const initHeader = (header) => {
    if (header.dataset.agMenuReady === 'true') return;
    header.dataset.agMenuReady = 'true';
    const mobileQuery = window.matchMedia('(max-width: 760px)');
    const mobileToggle = header.querySelector('[data-ag-mobile-menu-toggle]');
    const nav = header.querySelector('[data-ag-primary-nav]');
    const submenuItems = [...header.querySelectorAll('[data-ag-submenu]')];

    const setSubmenu = (item, open) => {
      item.classList.toggle('is-open', open);
      item.querySelector('[data-ag-submenu-toggle]')?.setAttribute('aria-expanded', String(open));
    };
    const closeSubmenus = (except = null) => submenuItems.forEach((item) => {
      if (item !== except) setSubmenu(item, false);
    });
    const setMobileMenu = (open) => {
      header.classList.toggle('ag-menu-open', open);
      mobileToggle?.setAttribute('aria-expanded', String(open));
      if (!open) closeSubmenus();
    };

    mobileToggle?.addEventListener('click', () => setMobileMenu(!header.classList.contains('ag-menu-open')));
    submenuItems.forEach((item) => {
      const toggle = item.querySelector('[data-ag-submenu-toggle]');
      toggle?.addEventListener('click', () => {
        const nextOpen = !item.classList.contains('is-open');
        closeSubmenus(item);
        setSubmenu(item, nextOpen);
      });
      item.addEventListener('pointerenter', () => {
        if (!mobileQuery.matches) {
          closeSubmenus(item);
          setSubmenu(item, true);
        }
      });
      item.addEventListener('pointerleave', () => {
        if (!mobileQuery.matches) setSubmenu(item, false);
      });
      item.addEventListener('focusin', () => {
        if (!mobileQuery.matches) {
          closeSubmenus(item);
          setSubmenu(item, true);
        }
      });
      item.addEventListener('focusout', () => window.setTimeout(() => {
        if (!mobileQuery.matches && !item.contains(document.activeElement)) setSubmenu(item, false);
      }, 0));
    });

    nav?.addEventListener('click', (event) => {
      if (mobileQuery.matches && event.target.closest('a')) setMobileMenu(false);
    });
    document.addEventListener('pointerdown', (event) => {
      if (!header.contains(event.target)) {
        closeSubmenus();
        if (mobileQuery.matches) setMobileMenu(false);
      }
    });
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeSubmenus();
        if (mobileQuery.matches) setMobileMenu(false);
        mobileToggle?.focus();
      }
    });
    mobileQuery.addEventListener?.('change', () => {
      setMobileMenu(false);
      closeSubmenus();
    });
  };

  const init = () => document.querySelectorAll('[data-ag-header]').forEach(initHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();